module.exports = __webpack_public_path__ + "fonts/7801ff1.eot";